import { Button } from '@/ui/design-system'

interface GuestTripCTAProps {
  onCreateAccount: () => void
}

export function GuestTripCTA({ onCreateAccount }: GuestTripCTAProps) {
  return (
    <div className="relative w-full overflow-hidden rounded-xl">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-adventure-700 via-adventure-800 to-adventure-900" />
      
      {/* Content */}
      <div className="relative z-10 px-6 sm:px-8 lg:px-12 py-12 sm:py-16">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">
            Ready to join the adventure?
          </h2>
          <p className="text-base sm:text-lg text-white/90 max-w-2xl mx-auto leading-relaxed">
            Create an account to unlock full trip access, collaborate with your crew, and never miss an update.
          </p>
          <div className="pt-2">
            <Button
              onClick={onCreateAccount}
              className="bg-white text-adventure-800 hover:bg-white/90 font-semibold px-8 py-3 rounded-lg transition-colors text-base"
            >
              Get Started — It's Free
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
